import { Validator } from './validator';

export class CommentValidator extends Validator {
  validateHelper({ data, configuration }) {
    const {
      input,
    } = data;

    const { maxLength, isRequired } = configuration;

    if ((input == null || input.length === 0) && isRequired) {
      return 'InputIsEmpty';
    }
    if (input && maxLength && input.length > maxLength) {
      return 'InputTooLong';
    }
    return null;
  }

  validate({ data, configuration }) {
    return this.validateHelper({ data, configuration }) == null;
  }

  getError({ data, configuration, i18n }) {
    const { maxLength } = configuration;

    const check = this.validateHelper({ data, configuration });

    if (check === 'InputTooLong') {
      return i18n.getString(_TL_('Field should not exceed {{maxLength}} characters'), { maxLength });
    }
    return undefined;
  }

  isAnswered({ data, configuration, i18n }) {
    const check = this.validateHelper({ data, configuration });
    if (check === 'InputIsEmpty') {
      return i18n.getString(_TL_('Please answer this question'));
    }
    return undefined;
  }
}
